import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../../store";
import { apiSlice } from "../apiSlice";

export const selectProgramEventListRaw =
  (programId: string) => (state: RootState) =>
    apiSlice.endpoints.getProgramEventList.select(programId)(state);

export const selectProgramEventListLoaded = (programId: string) =>
  createSelector(
    [selectProgramEventListRaw(programId)],
    (slice) => slice.status === "fulfilled"
  );

export const selectProgramEventListLoading = (programId: string) =>
  createSelector(
    [selectProgramEventListRaw(programId)],
    (slice) => slice.isLoading
  );

export const selectProgramEventList = (programId: string) =>
  createSelector(
    [selectProgramEventListRaw(programId)],
    (slice) => slice.data || []
  );
